import { backendServices } from 'common';
import { SIM_DOCUMENT_CLASS } from './_shared/simDocumentVM';
import { SupplierPendingSimRequestFlags } from './useSupplierPendingSimRequests';

export interface PostSignupSchedule {
    flags: SupplierPendingSimRequestFlags;
    /**
     * All `DocumentClass` ids from schedules with an open reminder. The static
     * SIM types (W-9, COI, Remittance) drive `flags`; remaining ids are
     * questionnaire `BusinessDocSubTypeId`s that the orchestrator
     * intersects with the buyer's authored questionnaires.
     */
    activeDocumentClasses: Set<number>;
}

/** Post-signup SIM steps from the schedules the supplier still has open reminders for. */
export function derivePostSignupFlags(
    schedules: backendServices.ViewModels.SIMDocumentTypeScheduleViewModel[]
): PostSignupSchedule {
    const activeDocumentClasses = new Set(schedules.map((s) => s.DocumentClass));

    return {
        flags: {
            taxDetails: activeDocumentClasses.has(SIM_DOCUMENT_CLASS.W9),
            certificateOfInsurance: activeDocumentClasses.has(SIM_DOCUMENT_CLASS.InsuranceCertificate),
            remittance: activeDocumentClasses.has(SIM_DOCUMENT_CLASS.Remittance),
        },
        activeDocumentClasses,
    };
}
